import { z } from 'zod';
import { oauthProviderSchema } from './auth';

export const metaResponseSchema = z.object({
  apiVersion: z.literal('v1'),
  /** Oldest app version the API still supports; older apps must ask the user to update. */
  minAppVersion: z.string(),
  /** Social sign-in providers configured on this server. */
  authProviders: z.array(oauthProviderSchema).default([]),
  /** Email and password on offer: without email there is no way back from a lost password. */
  passwordSignIn: z.boolean().default(true),
});
export type MetaResponse = z.infer<typeof metaResponseSchema>;
